import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import { Row, Col, Card, CardBody, Button, Spinner, Badge } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

import BootstrapTable from "react-bootstrap-table-next"
import { FaUserSecret, FaSearch } from "react-icons/fa" // Import this at the top

import { debounce, map, range } from "lodash"
import moment from "moment"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import MyPagination from "../../components/Common/MyPagination"
import Select from "react-select"

//actions
import "../../assets/scss/datatables.scss"
import { AvField, AvForm } from "availity-reactstrap-validation"
import DeleteModal from "components/Common/DeleteModal"
import { useHistory, useLocation } from "react-router-dom"
import { deleteInspection, getInspections } from "store/inspection/actions"
import { getExcelDownloadInspectionDocument, getUsers } from "store/actions"
import ExcelDownload from "hooks/useExcelDownloadButton"
import Settings from "components/VerticalLayout/Settings"

const AllInspections = ({ dashboard }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const isTablet = window.innerWidth <= 768

  const [totalItemLimit, setTotalItemLimit] = useState(() => {
    const limitFromStorage = parseInt(localStorage.getItem("inspectionLimit"))
    const isDashboard = window.location.pathname === "/dashboard"
    return isDashboard ? 5 : limitFromStorage || 10
  })
  const [page, setPage] = useState(null)
  const [SearchText, setSearchText] = useState("")

  const [downloadingId, setDownloadingId] = useState(null)
  const [isOpenSettings, setIsOpenSettings] = useState(false)

  const [Staff, setStaff] = useState("Select Staff...")
  const [StaffId, setStaffId] = useState("")
  const [StaffSearch, setStaffSearch] = useState("")

  useEffect(() => {
    setPage(1)
  }, [])

  const [finalDateFormated, setFinalDateFormated] = useState({
    from: "",
    to: "",
  })

  const {
    AllInspections,
    total,
    loading,
    allInspectionDocumentExcel,
    allStaffs,
  } = useSelector(state => ({
    AllInspections: state.Inspection.inspections?.inspectionDocuments,
    total: state.Inspection.inspections?.total,
    loading: state.Inspection.loading,
    allStaffs: state?.Members?.users?.users,
    allInspectionDocumentExcel:
      state.ExcelDownload.excelDownloadInspectionDocument?.inspectionDocuments,
  }))

  const handleDateSearch = () => {
    if (
      finalDateFormated?.from?.length >= 1 &&
      finalDateFormated?.to?.length >= 1
    ) {
      return finalDateFormated
    } else {
      return {
        from: "",
        to: "",
      }
    }
  }

  //delete
  const [isOpen, setIsOpen] = useState({ stauts: false, id: "" })
  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, stauts: false })
    dispatch(deleteInspection(isOpen?.id, history))
  }
  const handleDelete = id => {
    setIsOpen({ stauts: true, id: id })
  }
  const updatedLocation = {
    ...location,
    state: {
      ...location.state,
      page: 1,
    },
  }

  const updateURLParams = (key, value, extraState = {}) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set("p", 1)

    if (location?.pathname !== "/dashboard") {
      history.push({
        pathname: location.pathname,
        search: searchParams.toString(),
        state: {
          ...location.state,
          page: 1,
          ...extraState,
          [key]: value,
        },
      })
    }
  }

  //pagination
  const totalPages = Math.ceil(total / totalItemLimit)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    dispatch(
      getInspections(
        page,
        totalItemLimit,
        SearchText,
        StaffId,
        handleDateSearch()
      )
    )
  }, [dispatch, page, StaffId, totalItemLimit, SearchText, finalDateFormated])

  const onClickSettings = () => {
    setIsOpenSettings(true)
  }
  const onCloseClickSettings = () => {
    setIsOpenSettings(false)
  }

  const columns = [
    {
      dataField: "no",
      text: "No.",
      sort: true,
    },
    {
      dataField: "inspection_date",
      text: "Date",
      sort: true,
    },

    {
      dataField: "vehicle_no",
      text: "Vehicle No.",
      sort: true,
    },
    {
      dataField: "customer",
      text: "Customer Name",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone No.",
      sort: true,
    },
    {
      dataField: "vehicle",
      text: "Vehicle Model",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
    },
    {
      classes: "text-center action-cell",
      headerClasses: "text-center action-cell",
      dataField: "action",
      text: "Actions",
    },
  ]
  const handleRouteCreate = () => {
    history.push("/inspection/create")
  }
  const handleAllListPage = () => {
    history.push("/inspection/all")
  }
  const handleAllUpdatePage = id => {
    history.push(`/inspection/update/${id}`)
  }
  const handleSingleViewPage = id => {
    history.push(`/inspection/details/${id}`)
  }
  const inspectionData = map(
    AllInspections?.length >= 1 ? AllInspections : [],
    (item, index) => ({
      ...item,
      key: index,
      no: <span>{index + 1 + (page - 1) * totalItemLimit}</span>,
      inspection_date: moment(item?.inspection_data?.inspected_date).format(
        "DD/MM/YYYY"
      ),
      // user: <span>{item?.inspection_data?.inspected_by?.name}</span>,
      status: (
        <Badge
          style={{
            textTransform: "capitalize",
            fontSize: "12px",
            padding: "4px 8px",
          }}
          className={
            "px-2 py-1 badge-soft-" + (item?.is_completed ? "success" : "info")
          }
        >
          {item?.is_completed === true
            ? "Completed"
            : item?.is_completed === false
            ? "Processing"
            : "--"}
        </Badge>
      ),

      vehicle_no: <span>{item?.vehicle_data?.vehicle_number || "--"}</span>,
      inspection: (
        <span>
          {item?.inspection?.number} <br />
          {item?.inspection?.by}
        </span>
      ),
      customer: (
        <span>
          {item?.owner_details?.customer_name} <br />
        </span>
      ),
      vehicle: (
        <span>
          {item?.vehicle_data?.vehicle_model?.name || "--"} <br />
        </span>
      ),
      phone: (
        <span>
          {item?.owner_details?.phone_number} <br />
        </span>
      ),
      action: (
        <div style={{}}>
          <Button
            id={`view${index}`}
            title="View Document"
            type="button"
            color="white"
            className=" btn"
            onClick={() =>
              handleSingleViewPage(item?.inspection_data?.inspection_number)
            }
          >
            <i className="bx bx-show-alt " style={{ fontSize: "20px" }} />
          </Button>
          <Button
            title="Edit Document"
            id={`view${index}`}
            type="button"
            color="white"
            className=" btn"
            onClick={() =>
              handleAllUpdatePage(item?.inspection_data?.inspection_number)
            }
          >
            <i className="bx bx-edit " style={{ fontSize: "20px" }} />
          </Button>
          {/* <InspectionPDFDownload inspectionDetails={item} allList="All list" /> */}
          {item?.pdf_url?.url ? (
            <span title="Download PDF">
              <Button
                onClick={async () => {
                  setDownloadingId(item?._id) // Set loading for this item only

                  try {
                    const response = await fetch(item.pdf_url.url, {
                      mode: "cors",
                    })

                    const blob = await response.blob()
                    const url = window.URL.createObjectURL(blob)

                    const link = document.createElement("a")
                    const bookingId = item?.inspection?.booking_id || "Report"
                    const fileName = `Inspection_${bookingId}.pdf`

                    link.href = url
                    link.download = fileName
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(url)
                  } catch (err) {
                    // console.error("Download failed:", err)
                  } finally {
                    setDownloadingId(null) // Clear loading
                  }
                }}
                // className="rounded-pill"
                disabled={downloadingId === item?._id}
                style={{ backgroundColor: "unset", border: "unset" }}
              >
                {downloadingId === item?._id ? (
                  <Spinner
                    size="sm"
                    className="me-2"
                    style={{ color: "grey" }}
                  />
                ) : (
                  <i
                    className="bx bxs-file-pdf"
                    style={{ fontSize: "20px", color: "#f1b44c" }}
                  />
                )}
              </Button>
            </span>
          ) : (
            <span title="PDF has not been generated yet.">
              <Button type="button" color="white" className="btn">
                <i
                  className="bx bxs-file-pdf"
                  style={{ fontSize: "20px", color: "grey" }}
                />
              </Button>
            </span>
          )}
          <Button
            title="Delete Document"
            id={`Delete${index}`}
            type="button"
            color="white"
            className="ms-1 btn"
            onClick={() => {
              handleDelete(item?._id)
            }}
          >
            <i
              className="bx bx-trash "
              style={{
                color: "red",
                fontSize: "1.3rem",
              }}
            />
          </Button>
        </div>
      ),
    })
  )

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (type, { page, searchText }) => {
    setUserList()
  }

  const debounceUserSearch = debounce(value => setSearchText(value), 600)

  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
      localStorage.setItem("inspectionLimit", e.target.value)
    }
  }

  useEffect(() => {
    dispatch(getUsers("", "", StaffSearch, "", "inspectionUser"))
  }, [dispatch, StaffSearch])

  const staffOptions = [
    {
      label: "All",
      value: "",
    },
    {
      options: allStaffs?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result?._id,
      })),
    },
  ]

  const handleEntersStaffs = text => {
    setStaffSearch(text)
  }

  const handlerStaffsFinalValue = event => {
    setStaff(event?.label)
    setStaffId(event?.value)
    setPage(1)
  }

  const formattedCreateDates = item => {
    return moment(item?.inspection_data?.inspected_date).format(
      "DD/MM/YYYY h:m:a"
    )
  }

  const formattedUpdateDates = item => {
    return moment(item?.updatedAt).format("DD/MM/YYYY h:m:a")
  }

  const [isExcelLoading, setIsExcelLoading] = useState(false)

  const handleExcelDownload = async () => {
    setIsExcelLoading(true)
    try {
      await dispatch(
        getExcelDownloadInspectionDocument(
          page,
          totalItemLimit,
          SearchText,
          StaffId,
          handleDateSearch()
        )
      )
    } finally {
      setIsExcelLoading(false)
    }
  }

  const excelDownloadLeads = map(allInspectionDocumentExcel, (item, key) => ({
    ...item,
    no: key + 1,
    createdAt: formattedCreateDates(item),
    user: item?.inspection_data?.inspected_by?.name || "",
    vehicle_no: item?.vehicle_data?.vehicle_number,
    customer: item?.owner_details?.customer_name, // add other client data
    phone: item?.owner_details?.phone_number,
    vehicle: item?.vehicle_data?.vehicle_model?.name || "--",

    updatedAt: formattedUpdateDates(item),
  }))

  const headers = [
    { label: "No", key: "no" },
    { label: "Date", key: "createdAt" },
    { label: "User", key: "user" },
    { label: "Vehicle No.", key: "vehicle_no" },
    { label: "Customer Name", key: "customer" },
    { label: "Phone No.", key: "phone" },
    { label: "Vehicle Model", key: "vehicle" },

    { label: "Last Update", key: "updatedAt" },
  ]

  return (
    <React.Fragment>
      <Settings
        show={isOpenSettings}
        onCloseClick={() => onCloseClickSettings({ ...isOpenSettings })}
        state={isOpenSettings}
        setState={setIsOpenSettings}
      />
      <DeleteModal
        show={isOpen?.stauts}
        onCloseClick={() => setIsOpen({ ...isOpen, stauts: false })}
        onDeleteClick={handleDeleteEvent}
      />
      <Settings
        show={isOpenSettings}
        onCloseClick={() => onCloseClickSettings({ ...isOpenSettings })}
        state={isOpenSettings}
        setState={setIsOpenSettings}
      />
      {dashboard && (
        <h4 className="pl-2" style={{ fontWeight: "600", paddingLeft: "15px" }}>
          Inspections
        </h4>
      )}

      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <div className="document-list">
                <ToolkitProvider
                  keyField="_id"
                  columns={columns}
                  data={inspectionData}
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <div>
                        <div
                          title="Edit Payment Type"
                          style={{ cursor: "pointer" }}
                          onClick={() => onClickSettings()}
                          disabled={open}
                          className="d-flex align-items-center justify-content-end mt-0 mx-2"
                        >
                          <span style={{ textTransform: "capitalize" }}>
                            <i className="mdi mdi-cog" />
                          </span>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between py-3 px-2 flex-wrap">
                        <div className="d-flex justify-content-between ">
                          <div>
                            <AvForm className="form-horizontal mx-2 mb-0 d-flex align-items-center">
                              <div className="mx-1">
                                <span className="">
                                  Show
                                  {/* <i className="fas fa-sort-numeric-down-alt mx-1"></i> */}
                                </span>
                              </div>
                              <div className="" style={{ width: "50px" }}>
                                <AvField
                                  name="pageLimit"
                                  className="form-control"
                                  value={totalItemLimit}
                                  onChange={e => handlePageLimit(e)}
                                  type="text"
                                  required
                                />
                              </div>
                            </AvForm>
                          </div>
                        </div>
                        <div
                          className="w-20 text-align-center me-1 "
                          style={{}}
                        >
                          <AvForm
                            style={{
                              marginTop: !isTablet && "-20px",
                              alignItems: "center",
                            }}
                          >
                            <span className="mt-1 ">Inspection Date</span>
                            <div className={`d-flex date_wrapper  `}>
                              <div className="d-flex align-items-start position-relative">
                                <AvField
                                  name="dateRange"
                                  type="date"
                                  validate={{
                                    dateRange: {
                                      start: { value: -5, units: "years" },
                                      end: { value: 5, units: "years" },
                                    },
                                  }}
                                  onChange={e => {
                                    setFinalDateFormated({
                                      ...finalDateFormated,
                                      from: e.target.value,
                                    })
                                    history.push(updatedLocation)
                                  }}
                                  value={finalDateFormated?.from}
                                />
                                <button
                                  onClick={() => {
                                    setFinalDateFormated({
                                      ...finalDateFormated,
                                      from: "",
                                    })
                                    history.push(updatedLocation)
                                  }}
                                  type="button"
                                  className="btn btn-white editable-cancel date_close btn-sm"
                                >
                                  <i className="mdi mdi-close text-danger "></i>
                                </button>
                              </div>
                              <div className="d-flex align-items-start position-relative">
                                <AvField
                                  name="dateRange"
                                  className="mx-1"
                                  type="date"
                                  validate={{
                                    dateRange: {
                                      start: { value: -5, units: "years" },
                                      end: { value: 5, units: "years" },
                                    },
                                  }}
                                  onChange={e =>
                                    setFinalDateFormated({
                                      ...finalDateFormated,
                                      to: e.target.value,
                                    })
                                  }
                                  value={finalDateFormated?.to}
                                />
                                <button
                                  onClick={() =>
                                    setFinalDateFormated({
                                      ...finalDateFormated,
                                      to: "",
                                    })
                                  }
                                  type="button"
                                  className="btn btn-white editable-cancel date_close btn-sm"
                                >
                                  <i className="mdi mdi-close text-danger "></i>
                                </button>
                              </div>
                            </div>
                          </AvForm>
                        </div>
                        <div
                          className="w-20 text-align-center me-0"
                          style={{
                            width: "21%",
                            marginTop: isTablet ? "0px" : "-20px",
                          }}
                        >
                          <label className="form-label mb-0">
                            Inspection User
                          </label>
                          <Select
                            onInputChange={handleEntersStaffs}
                            value={Staff}
                            placeholder={Staff}
                            onChange={handlerStaffsFinalValue}
                            options={staffOptions}
                            classNamePrefix="select2-selection"
                            isLoading={loading}
                          />
                        </div>

                        <div className={`w-20 ${isTablet ? "mt-3" : ""}`}>
                          <div className="search-box d-flex">
                            <div className="position-relative ">
                              <AvForm>
                                <AvField
                                  name="searchText"
                                  placeholder="Search..."
                                  type="text"
                                  onChange={e =>
                                    debounceUserSearch(e.target.value)
                                  }
                                  style={{
                                    width: isTablet ? "200px" : "200px",
                                    // borderRadius: "6px",
                                  }}
                                />
                              </AvForm>
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </div>
                        {!dashboard && (
                          <div
                            className={`pb-0 d-flex align-items-center justify-content-end ${
                              isTablet ? "mt-3" : ""
                            }`}
                          >
                            <div>
                              <Button
                                color="warning"
                                className="px-3 py-1  btn-rounded   d-flex align-items-center"
                                onClick={handleRouteCreate}
                              >
                                {/* <i
                                  className="mdi mdi-plus  mr-2 fs-5"
                                  style={{ marginRight: "8px" }}
                                />
                                Create{" "} */}
                                <span
                                  style={{
                                    position: "relative",
                                    marginRight: "8px",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                >
                                  <FaUserSecret
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      fontSize: "16px",
                                    }}
                                  />
                                  <FaSearch
                                    style={{
                                      position: "absolute",
                                      bottom: 0,
                                      right: -4,
                                      fontSize: "10px",
                                    }}
                                  />
                                </span>
                                Inspect Car
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>

                      {loading ? (
                        <Spinner color="secondary" className="d-block m-auto" />
                      ) : (
                        <>
                          {AllInspections?.length ? (
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    // keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // defaultSorted={defaultSorted}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    onTableChange={handleTableChange}
                                  />
                                </div>
                              </Col>
                            </Row>
                          ) : (
                            <p
                              className="my-4 mx-3 "
                              style={{ textTransform: "capitalize" }}
                            >
                              No Inspections!
                            </p>
                          )}
                          <div className="d-flex align-items-center justify-content-between px-4">
                            {!dashboard && (
                              <div className="w-100">
                                <MyPagination
                                  totalPages={pages}
                                  page={page}
                                  setPage={setPage}
                                />
                              </div>
                            )}
                            <div>
                              {!dashboard && (
                                <>
                                  {AllInspections?.length >= 1 ? (
                                    <ExcelDownload
                                      title="Inspection Document Reports"
                                      headers={headers}
                                      excelDownloadData={excelDownloadLeads}
                                      isLoading={isExcelLoading}
                                      onDownloadClick={handleExcelDownload}
                                    />
                                  ) : null}
                                </>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {dashboard && (
        <Row className="w-100">
          <p
            onClick={handleAllListPage}
            className="mt-0 ml-3 pr-0 mb-0 text-end w-100 cursor-pointer"
            style={{ textTransform: "capitalize" }}
          >
            View All <span>&gt;</span>
          </p>
        </Row>
      )}
    </React.Fragment>
  )
}

export default AllInspections

AllInspections.propTypes = {
  dashboard: PropTypes.any,
}
